/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-object-literal-type-assertion */
import { DraftingAccrediationStorePayload } from '@resources/scripts/models';
import draftingAccredion from '@resources/scripts/services/draftingAccrediation.service';
import draftingAccrediationApi from '@resources/scripts/services/api/draftingAccreditation.api';
import transactionApi from '@resources/scripts/services/api/transaction.api';
import axios from 'axios';
import { DRAFTING_ACCREDITION_FORM } from '../mutation-types';
import { setState } from '../mutationHelpers';

const namespaced = true;

const state = {
  formFields: {
    validApplication: false,
    pledgeOfEthics: false,
    draftingPolicies: false,
    applicantEligibility: false,
    applicantFirstName: '',
    applicantLastName: '',
    titlePosition: '',
    applicantCountry: '',
    applicantCompanyAddressLine1: '',
    applicantCompanyAddressLine2: '',
    applicantCompanyCity: '',
    applicantCompanyState: '',
    applicantCompanyZip: '',
    applicantEmail: '',
    applicantPhone: '',
    applicantFax: '',
    draftingExperience: '',
    awiStandards: [],
    referralInfo: '',
    otherReferred: '',
    firmContactEmail: '',
    firmContactCity: '',
    firmContactStateProvince: '',
    referenceFirstName: '',
    referenceLastName: '',
    referenceTitlePosition: '',
    referenceCountry: '',
    referenceAddressLineOne: '',
    referenceAddressLineTwo: '',
    referenceCity: '',
    referenceState: '',
    referenceZipCode: '',
    referenceEmailAddress: '',
    referencePhone: '',
    referenceFax: '',
    secondReferenceFirstName: '',
    secondReferenceLastName: '',
    secondReferenceTitlePosition: '',
    secondReferenceCountry: '',
    secondReferenceAddressLineOne: '',
    secondReferenceAddressLineTwo: '',
    secondReferenceCity: '',
    secondReferenceState: '',
    secondReferenceZipCode: '',
    secondReferenceEmailAddress: '',
    secondReferencePhone: '',
    secondReferenceFax: '',
    billingFirstName: '',
    billingLastName: '',
    billingAddressLine1: '',
    billingAddressLine2: '',
    billingCity: '',
    billingState: '',
    billingZip: '',
    billingPhone: '',
    billingEmail: '',

    nameOnCard: '',
    cardNumber: '',
    cardCVV: '',
    cardExpMonth: '',
    cardExpYear: '',
    billingComments: '',
    transactionAmount: 0,
  } as DraftingAccrediationStorePayload,
  currentPage: 1,
  countryOptions: [],
  submitting: false,
  submitted: false,
};

const getters = {
  countryOptions: storeState => storeState.countryOptions,
  stateProvinceOptions: storeState => countryName => (storeState.countryOptions.find(x => x.name === countryName) ? storeState.countryOptions.find(x => x.name === countryName).stateProvinces : []),
  formFields: storeState => storeState.formFields,
  currentPage: storeState => storeState.currentPage,
  submitting: storeState => storeState.submitting,
  submitted: storeState => storeState.submitted,
};

const mutations = {
  [DRAFTING_ACCREDITION_FORM.UPDATE_COUNTRY_OPTIONS]: setState('countryOptions'),
  [DRAFTING_ACCREDITION_FORM.CHANGE_CURRENT_PAGE]: setState('currentPage'),
  [DRAFTING_ACCREDITION_FORM.TOGGLE_SUBMITTED_STATE]: setState('submitted'),
  [DRAFTING_ACCREDITION_FORM.TOGGLE_SUBMITTING_STATE]: setState('submitting'),

  [DRAFTING_ACCREDITION_FORM.FORM_FIELDS](formState, fields) {
    Object.assign(formState.formFields, fields);
  },

  [DRAFTING_ACCREDITION_FORM.UPDATE_PRICE](formState, value) {
    formState.formFields.transactionAmount = value;
  },
};

const actions = {
  goToNextPage({ commit, state: actionState }) {
    commit(DRAFTING_ACCREDITION_FORM.CHANGE_CURRENT_PAGE, actionState.currentPage + 1);
    window.scrollTo(0, 0);
  },

  goToPrevPage({ commit, state: actionState }) {
    commit(DRAFTING_ACCREDITION_FORM.CHANGE_CURRENT_PAGE, actionState.currentPage - 1);
    window.scrollTo(0, 0);
  },

  setPrice({ commit }, payload) {
    commit(DRAFTING_ACCREDITION_FORM.UPDATE_PRICE, payload);
  },

  async getCountries({ commit }) {
    const { data } = await axios.get('/api/countries');
    commit(DRAFTING_ACCREDITION_FORM.UPDATE_COUNTRY_OPTIONS, data);
  },

  submitForm({ commit, state: actionState }) {
    return new Promise(async (resolve, reject) => {
      commit(DRAFTING_ACCREDITION_FORM.TOGGLE_SUBMITTING_STATE, true);
      const createPayload = draftingAccredion.buildCreatePayload(actionState.formFields);
      try {
        const { data: transactionData } = await transactionApi.addTransaction({
          type: 'DRAFTER_APPLY',
          nameOnCard: actionState.formFields.nameOnCard,
          companyName: createPayload.applicant.organizationName,
          billingAddress1: actionState.formFields.billingAddressLine1,
          billingAddress2: actionState.formFields.billingAddressLine2,
          billingCity: actionState.formFields.billingCity,
          billingStateProvince: actionState.formFields.billingState,
          billingZip: actionState.formFields.billingZip,
          billingPhone: actionState.formFields.billingPhone,
          billingEmail: actionState.formFields.billingEmail,
          cardNumber: actionState.formFields.cardNumber,
          CardExpireMonth: actionState.formFields.cardExpMonth,
          cardExpireYear: actionState.formFields.cardExpYear,
          cVV2: actionState.formFields.cardCVV,
          comments: actionState.formFields.billingComments,
          description: 'New Drafting Accrediation Application',
          amount: actionState.formFields.transactionAmount,
        });
        const { data: formResult } = await draftingAccrediationApi.create(createPayload);
        await draftingAccrediationApi.associateTransaction(formResult, transactionData.id);
        commit(DRAFTING_ACCREDITION_FORM.TOGGLE_SUBMITTED_STATE, true);
        try {
          // eslint-disable-next-line @typescript-eslint/no-angle-bracket-type-assertion
          (<any>window).gtag('config', 'UA-69171335-1', {
            page_title: 'Drafting Accrediation - Submitted',
            page_path: '/forms/drafting-accrediation/submitted',
          });
        } catch (error) {}
        resolve();
      } catch (error) {
        commit(DRAFTING_ACCREDITION_FORM.TOGGLE_SUBMITTING_STATE, false);
        reject(error);
      }
    });
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};